export const isTabGrid = (parentSource?: string | null): boolean => parentSource === 'tab';

/**
 * Resolves the parent relationship value expected by grid save requests.
 *
 * Legacy behaviour (grid.js GetObjectToSave):
 *   - parentSource === "tab" && tabsKey exists → send tabsKey as-is (no composite)
 *   - parentSource === "tab" && tabsKey absent → send bare parentId as fallback
 *   - otherwise → send `key#|#id`
 *
 * @param parentId
 * @param parentSource
 * @param detailFormKey
 * @param parentGridKey
 * @param tabsKey - the tab block key from the containing detail form (only for tab grids)
 */
export const resolveGridParentId = ({
  parentId,
  parentSource,
  detailFormKey,
  parentGridKey,
  tabsKey,
}: {
  parentId?: string;
  parentSource?: string | null;
  detailFormKey?: string;
  parentGridKey?: string;
  tabsKey?: string;
}): string | undefined => {
  if (!parentId) return undefined;

  if (isTabGrid(parentSource)) {
    // Tab grids: send tabsKey verbatim if present, otherwise bare parentId
    return tabsKey ?? parentId;
  }

  // Non-tab grids: composite key#|#id
  const parentKey = parentGridKey ?? detailFormKey;
  return parentKey ? `${parentKey}#|#${parentId}` : parentId;
};
